import React from 'react';
import styles from './Footer.module.css';

interface FooterMenuItemProps {
	href: string;
	children: React.ReactNode;
}

const FooterMenuItem: React.FC<FooterMenuItemProps> = ({href, children}) => {
	return (
		<li className={styles.menuFooter__item}>
			<a href={href} className={styles.menuFooter__link}>
				{children}
			</a>
		</li>
	);
};

export default FooterMenuItem;

